<template>
  <div class="ccui-app-box-iframe-operate-container">
    <template v-if="labelShow">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
    </template>
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <el-tabs class="el-tabs__customize" value="1">
          <el-tab-pane :label="breadcrumbData.titname" name="1">
            <template v-if="subPackageFlag">
              <el-tabs class="customeTab" v-model="active">
                <el-tab-pane
                  v-for="(listItem, listIndex) in listData"
                  :key="listItem.packId"
                  :label="listItem.packName"
                  :name="listIndex + ''"
                >
                  <template
                    v-if="
                      type == 0 &&
                        isCheckedHighAndLow &&
                        active2 == '2' &&
                        status == 1
                    "
                  >
                    <div class="remarkTip fl">
                      备注：红色分值为去掉的最高分或最低分
                    </div>
                  </template>

                  <el-tabs class="summaryTab" v-model="active2">
                    <el-tab-pane label="汇总表" name="1">
                      <el-table :data="listItem.summaryTableData" border>
                        <template
                          v-for="(item, index) in listItem.summaryColumns"
                        >
                          <el-table-column
                            :key="index"
                            :show-overflow-tooltip="true"
                            v-bind="item"
                            v-if="item.labelChild && item.labelChild.length > 0"
                          >
                            <el-table-column
                              v-for="(child, indexch) in item.labelChild"
                              :key="indexch"
                              align="center"
                              v-bind="child"
                            >
                            </el-table-column>
                            <template slot-scope="scope">
                              <span v-if="item.money">{{
                                scope.row[item.prop] !== ""
                                  ? new BigNumber(
                                      scope.row[item.prop]
                                    ).toFormat(2)
                                  : ""
                              }}</span>
                              <span v-else>{{ scope.row[item.prop] }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            :key="index"
                            :show-overflow-tooltip="true"
                            v-bind="item"
                            v-if="!item.labelChild"
                          >
                            <template slot-scope="scope">
                              <span v-if="item.money">{{
                                scope.row[item.prop] !== ""
                                  ? new BigNumber(
                                      scope.row[item.prop]
                                    ).toFormat(2)
                                  : ""
                              }}</span>
                              <span v-else>{{ scope.row[item.prop] }}</span>
                            </template>
                          </el-table-column>
                        </template>
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
              </el-tabs>
            </template>
            <template v-else>
              <div v-for="(listItem, listIndex) in listData" :key="listIndex">
                <el-tabs value="1" class="summaryTab summaryTabTwo">
                  <el-tab-pane label="汇总表" name="1">
                    <!-- <div class="ccui-tab-iframe">
                      <div class="ccui-tab-wrapper">
                        <el-button type="table-top" size="mini">
                          汇总表
                        </el-button>
                      </div>
                    </div> -->
                    <el-table :data="listItem.summaryTableData" border>
                      <template
                        v-for="(item, index) in listItem.summaryColumns"
                      >
                        <el-table-column
                          :key="index"
                          :show-overflow-tooltip="true"
                          v-bind="item"
                          v-if="item.labelChild && item.labelChild.length > 0"
                        >
                          <el-table-column
                            v-for="(child, indexch) in item.labelChild"
                            :key="indexch"
                            align="center"
                            v-bind="child"
                          >
                          </el-table-column>
                          <template slot-scope="scope">
                            <span v-if="item.money">{{
                              scope.row[item.prop] !== ""
                                ? new BigNumber(scope.row[item.prop]).toFormat(
                                    2
                                  )
                                : ""
                            }}</span>
                            <span v-else>{{ scope.row[item.prop] }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :key="index"
                          :show-overflow-tooltip="true"
                          v-bind="item"
                          v-if="!item.labelChild"
                        >
                          <template slot-scope="scope">
                            <span v-if="item.money">{{
                              scope.row[item.prop] !== ""
                                ? new BigNumber(scope.row[item.prop]).toFormat(
                                    2
                                  )
                                : ""
                            }}</span>

                            <span v-else>{{ scope.row[item.prop] }}</span>
                          </template>
                        </el-table-column>
                      </template>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <template v-if="operateShow">
      <div class="operate">
        <template v-if="billStatus == 0">
          <!-- <template
            v-if="listData[parseInt(active)].summaryTableData.length === 0"
          > -->
          <template>
            <el-button
              type="text"
              icon="icon-ccui-save"
              v-preventReClick
              v-if="showStart"
              @click="operateSummary"
              >提交汇总</el-button
            >
            <el-button
              type="text"
              icon="icon-ccui-cancel"
              v-if="showStart"
              @click="closeScro"
              >取消</el-button
            >
          </template>
          <!-- <template
            v-if="listData[parseInt(active)].summaryTableData.length > 0"
          >
            <el-button
              type="text"
              icon="el-icon-refresh-right"
              v-preventReClick
              @click="operateSummary"
              >重新汇总</el-button
            >
          </template>
          <template v-if="submitFlag && billStatus != '1'">
            <el-button
              type="text"
              icon="icon-ccui-agree"
              v-preventReClick
              @click="dealSumScoreSubmit"
              >提交</el-button
            >
          </template> -->
        </template>
        <el-button
          v-if="!showStart"
          type="text"
          icon="icon-ccui-sharing-o"
          @click="refresh"
          >刷新</el-button
        >
      </div>
    </template>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpListPurchaseSchemePackageApi,
  scpQrySumScoreApi,
  scpQrySumScoreExpertScoreListApi,
  scpDealSumScoreSaveApi,
  scpDealSumScoreSubmitApi,
  scpQryBidEvaProcessStatusApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

export default {
  name: "summaryingOrComplete", // 汇总中/汇总完成
  components: {
    breadcrumbSourcing
  },
  inject: ["reload"],
  props: {
    type: {
      type: Number, // 0: 技术评分汇总 1：商务技术评分汇总
      default: 0
    },
    showStart: {
      type: Boolean, // 开始打分汇总
      default: false
    },
    isZy: {
      type: Boolean, // 是否是组员
      default: false
    },
    status: {
      type: Number, // 0: 汇总中 1：汇总完成
      default: 0
    }
  },
  data() {
    let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      breadcrumbData: {
        titname: this.isZy ? "打分汇总查看" : "打分汇总",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      billStatus: "0",
      labelType: this.billStatus == 0 ? "InSummary" : "SummaryComplete",
      listData: [],
      // summaryTableData: [],
      active: "0",
      active2: "1",
      summaryColumns: [
        {
          prop: "id",
          label: "序号",
          width: 55
        },
        {
          prop: "supName",
          label: "分包商",
          width: 200
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        {
          prop: "taxAmount",
          label: "税额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          width: 200,
          align: "right",
          money: true
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术加分项",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务加分项",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "投标报价",
          labelChild: [],
          align: "center"
        },
        {
          // prop: this.type == 1 ? "sumScore" : "techSumScore",
          prop: "sumScore",
          label: "汇总得分",
          width: 110
        }
        // {
        //   prop: "lostFlagStr",
        //   label: "是否淘汰",
        //   width: 110
        // },
        // {
        //   prop: "lostReason",
        //   label: "淘汰理由",
        //   width: 250
        // }
      ],
      columns: [
        {
          prop: "id",
          label: "序号",
          width: 55,
          fixed: true
        },
        {
          prop: "expertName",
          label: "评分专家",
          width: 170,
          fixed: true
        },
        {
          prop: "supName",
          label: "分包商",
          width: 200,
          fixed: true
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        {
          prop: "taxAmount",
          label: "税额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          width: 200,
          align: "right",
          money: true
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术加分项",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务加分项",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "投标报价",
          labelChild: [],
          width: 200,
          align: "center"
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 110
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 350
        },
        {
          prop: "updateTime",
          label: "评分提交时间",
          width: 170
        }
      ],
      evaForm: JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
        .evaForm, // 1：技术商务组合评分 2：技术商务分开评分
      labelShow: false,
      operateShow: false,
      subPackageFlag: false, // 是否分包件 false:不分包
      submitFlag: false, // 提交按钮是否展示，任一包件有汇总数据都可展示
      isCheckedHighAndLow: false, // 是否选中了去除技术评分的最高最低
      purchaseType: "",
      BigNumber: BigNumber,
      expertSelection: [] //选择的退回专家
    };
  },
  watch: {
    active: function(newValue, oldValue) {
      this.active2 = "1";
    },
    purchaseType: {
      handler(newVal) {
        if (
          newVal == "1" ||
          newVal == "2" ||
          newVal == "4" ||
          newVal == "7" ||
          newVal == "8"
        ) {
          // this.summaryColumns.forEach(item => {
          //   if (item.prop == "sscScoreItemBOS") {
          //     item.label = "响应报价";
          //   }
          // });
          // this.columns.forEach(item => {
          //   if (item.prop == "sscScoreItemBOS") {
          //     item.label = "响应报价";
          //   }
          // });
        }
      },
      immediate: true
    }
  },
  created() {
    console.log(this.type, "this.type..");
    if (this.type == "0") {
      this.summaryColumns.push(
        {
          prop: "lostFlagStr",
          label: "是否淘汰",
          width: 110
        },
        {
          prop: "lostReason",
          label: "淘汰理由",
          width: 250
        }
      );
    }
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      this.summaryColumns.splice(4, 1);
      this.columns.splice(5, 1);
    }

    this.getData();
  },
  methods: {
    // 修改打分表的数据，给打分表加上税额，不含税金额
    getPriceAmount(table, data, listIndex) {
      return true;
    },

    // 刷新
    refresh() {
      this.getData();
    },
    toSkill() {
      this.$emit("start", 1);
    },
    getData() {
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey,
        evaPurStep: this.$router.history.current.query.evaPurStep
      }).then(res => {
        this.$set(this, "labelShow", false);
        this.$set(this, "billStatus", res.data.data.billStatus);
        this.$set(
          this,
          "labelType",
          res.data.data.billStatus === "1" ? "InSummary" : "SummaryComplete"
        ); // 0:制定中 1：制定完成
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.active = "0";
        this.active2 = "1";
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.$set(this, "labelShow", true);
      });
      scpListPurchaseSchemePackageApi({
        pageNo: -1,
        pageSize: -1,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
        let arr = [];
        if (this.subPackageFlag) {
          res.data.data.purchaseSchemePackageList.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              arr.push(this.getSumAndExpertScore(item.packId, item.packName));
            }
          });
        } else {
          arr.push(this.getSumAndExpertScore("", ""));
        }
        console.log("res", res);
        Promise.all(arr).then(res1 => {
          if (res1 && res1.length > 0) {
            // 通过包件id进行排序
            res1.sort(function(a, b) {
              if (a.joinExpertId > b.joinExpertId) {
                return 1;
              } else if (a.joinExpertId < b.joinExpertId) {
                return -1;
              } else {
                return 0;
              }
            });
            res1.forEach((item, index) => {
              item.summaryColumns = JSON.parse(
                JSON.stringify(this.summaryColumns)
              ); // 汇总表
              item.columns = JSON.parse(JSON.stringify(this.columns));

              // 打分表逻辑开始
              let skillChild = []; // 技术评分的表头
              let bidChild = []; // 投标报价
              let commonChild = []; // 商务评分的表头
              let commonChild2 = []; // 技术加分项评分的表头
              let commonChild3 = []; // 商务加分项评分的表头
              let devspan = 0; // 之前行的数
              let data = []; // 数据
              let id = 0; // 序号
              item.expertList.forEach((aItem, aIndex) => {
                id++;
                if (aIndex > 0) {
                  devspan +=
                    item.expertList[aIndex - 1].sscSupQuoteScoreBOS.length;
                  // item.expertList[aIndex - 1].sscSupQuoteScoreBOS.forEach(a => {
                  //   devspan += a.sscSupScoreBOS.length;
                  // });
                }
                aItem.sscSupQuoteScoreBOS.forEach((bItem, bIndex) => {
                  let columnCount = 10; // 总共有多少列，用于计算最后一列的合并
                  bItem.sscSupScoreBOS.forEach(b => {
                    columnCount += b.sscSupScoreItemBOS.length;
                  });
                  let obj = {
                    id: id,
                    joinExpertId: aItem.joinExpertId,
                    expertName: aItem.expertName,
                    supJoinId: bItem.supJoinId,
                    supQuoteId: bItem.supQuoteId,
                    supCode: bItem.supCode,
                    supName: bItem.supName,
                    priceAmount: bItem.priceAmount,
                    noTaxPriceAmount: bItem.noTaxPriceAmount,
                    taxAmount: bItem.taxAmount,
                    supScore: bItem.supScore,
                    scoreDesc: bItem.scoreDesc,
                    updateTime: bItem.updateTime,
                    devspan: devspan,
                    rowspan: aItem.sscSupQuoteScoreBOS.length,
                    columnCount: columnCount,
                    industryTypeName: bItem.industryTypeName,
                    companyTypeName: bItem.companyTypeName,
                    supCategoryName: bItem.supCategoryName,
                    supLevelName: bItem.supLevelName,
                    supTypeNewName: bItem.supTypeNewName
                  };
                  console.log(obj, "<<<obj");

                  bItem.sscSupScoreBOS.forEach((cItem, cIndex) => {
                    cItem.sscSupScoreItemBOS.forEach((dItem, dIndex) => {
                      obj.scoreRule = dItem.scoreRule;
                      let props =
                        "supScore-" + cItem.scoreItem + "-" + dItem.scoreItemId;
                      obj[props] =
                        dItem.supScore &&
                        new BigNumber(dItem.supScore).toFormat(2);
                      if (cItem.scoreItem === "0") {
                        let scoreMaxMin =
                          "scoreMaxMin-" +
                          +cItem.scoreItem +
                          "-" +
                          dItem.scoreItemId;
                        obj[scoreMaxMin] =
                          dItem.scoreMaxMin &&
                          new BigNumber(dItem.scoreMaxMin).toFormat(2);
                        if (
                          skillChild.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                cItem.scoreItem +
                                "-" +
                                dItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          skillChild.push({
                            prop: props,
                            label: dItem.scoreRule,
                            scoreMaxMin: scoreMaxMin,
                            width: 120
                          });
                        }
                      }
                      if (cItem.scoreItem === "5") {
                        let scoreMaxMin =
                          "scoreMaxMin-" +
                          +cItem.scoreItem +
                          "-" +
                          dItem.scoreItemId;
                        obj[scoreMaxMin] =
                          dItem.scoreMaxMin &&
                          new BigNumber(dItem.scoreMaxMin).toFormat(2);
                        if (
                          bidChild.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                cItem.scoreItem +
                                "-" +
                                dItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          bidChild.push({
                            prop: props,
                            label: dItem.scoreRule,
                            scoreMaxMin: scoreMaxMin,
                            width: 120
                          });
                        }
                      }
                      if (cItem.scoreItem === "1") {
                        let scoreMaxMin =
                          "scoreMaxMin-" +
                          +cItem.scoreItem +
                          "-" +
                          dItem.scoreItemId;
                        obj[scoreMaxMin] = dItem.scoreMaxMin;
                        if (
                          commonChild.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                cItem.scoreItem +
                                "-" +
                                dItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          commonChild.push({
                            prop: props,
                            label: dItem.scoreRule,
                            scoreMaxMin: scoreMaxMin,
                            width: 120
                          });
                        }
                      }
                      if (cItem.scoreItem === "2") {
                        let scoreMaxMin =
                          "scoreMaxMin-" +
                          +cItem.scoreItem +
                          "-" +
                          dItem.scoreItemId;
                        obj[scoreMaxMin] = dItem.scoreMaxMin;
                        if (
                          commonChild2.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                cItem.scoreItem +
                                "-" +
                                dItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          commonChild2.push({
                            prop: props,
                            label: dItem.scoreRule,
                            scoreMaxMin: scoreMaxMin,
                            width: 120
                          });
                        }
                      }
                      if (cItem.scoreItem === "3") {
                        let scoreMaxMin =
                          "scoreMaxMin-" +
                          +cItem.scoreItem +
                          "-" +
                          dItem.scoreItemId;
                        obj[scoreMaxMin] = dItem.scoreMaxMin;
                        if (
                          commonChild3.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                cItem.scoreItem +
                                "-" +
                                dItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          commonChild3.push({
                            prop: props,
                            label: dItem.scoreRule,
                            scoreMaxMin: scoreMaxMin,
                            width: 120
                          });
                        }
                      }
                    });
                  });
                  data.push(obj);
                });
              });
              if (skillChild.length + commonChild.length < 3) {
                if (this.type == 1) {
                  delete item.columns[9].width;
                } else {
                  delete item.columns[10].width;
                }
              }
              if (this.type == 0) {
                // 技术评分汇总
                item.columns[8].labelChild = skillChild;
                item.columns[9].labelChild = commonChild2;
                item.columns[12].labelChild = bidChild;
              }
              if (this.type == 1) {
                // 技术商务评分汇总
                if (this.evaForm == "1") {
                  // 组合评分
                  item.columns[8].labelChild = skillChild;
                  item.columns[9].labelChild = commonChild2;
                  item.columns[10].labelChild = commonChild;
                  item.columns[11].labelChild = commonChild3;
                  item.columns[12].labelChild = bidChild;
                } else if (this.evaForm == "2") {
                  // 分开评分
                  item.columns[10].labelChild = commonChild;
                  item.columns[11].labelChild = commonChild3;
                } else {
                  // 商务评分
                  item.columns[10].labelChild = commonChild;
                  item.columns[11].labelChild = commonChild3;
                }
              }
              item.data = data;
              console.log(data, "<>>>>");

              // 汇总表逻辑开始
              let sumSkillChild = []; // 汇总表技术评分表头
              let sumCommonChild = []; // 打分表技术评分表头
              let sumBidChild = []; // 投标报价分项
              let sumCommonChild2 = []; // 技术加分项
              let sumCommonChild3 = []; // 商务加分项
              if (item.summaryTableData && item.summaryTableData.length > 0) {
                item.summaryTableData.forEach((sumItem, sumIndex) => {
                  sumItem.id = sumIndex + 1;
                  sumItem.lostFlagStr =
                    sumItem.lostFlag == "1" ? "淘汰" : "不淘汰";
                  sumItem.sscSupScoreSumItemBOS.forEach(
                    (scoreSumItem, scoreSumIndex) => {
                      let props =
                        "supScore-" +
                        scoreSumItem.scoreItem +
                        "-" +
                        scoreSumItem.scoreItemId;
                      sumItem[props] =
                        scoreSumItem.supScore &&
                        new BigNumber(scoreSumItem.supScore).toFormat(2);
                      if (scoreSumItem.scoreItem === "1") {
                        if (
                          sumCommonChild.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                scoreSumItem.scoreItem +
                                "-" +
                                scoreSumItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          sumCommonChild.push({
                            prop: props,
                            label: scoreSumItem.scoreRule,
                            width: 120
                          });
                        }
                      }
                      if (scoreSumItem.scoreItem === "0") {
                        if (
                          sumSkillChild.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                scoreSumItem.scoreItem +
                                "-" +
                                scoreSumItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          sumSkillChild.push({
                            prop: props,
                            label: scoreSumItem.scoreRule,
                            width: 120
                          });
                        }
                      }
                      if (scoreSumItem.scoreItem === "5") {
                        if (
                          sumBidChild.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                scoreSumItem.scoreItem +
                                "-" +
                                scoreSumItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          sumBidChild.push({
                            prop: props,
                            label: scoreSumItem.scoreRule,
                            width: 120
                          });
                        }
                      }

                      if (scoreSumItem.scoreItem === "2") {
                        if (
                          sumCommonChild2.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                scoreSumItem.scoreItem +
                                "-" +
                                scoreSumItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          sumCommonChild2.push({
                            prop: props,
                            label: scoreSumItem.scoreRule,
                            width: 120
                          });
                        }
                      }
                      if (scoreSumItem.scoreItem === "3") {
                        if (
                          sumCommonChild3.filter(item => {
                            return (
                              item.prop ===
                              "supScore-" +
                                scoreSumItem.scoreItem +
                                "-" +
                                scoreSumItem.scoreItemId
                            );
                          }).length === 0
                        ) {
                          sumCommonChild3.push({
                            prop: props,
                            label: scoreSumItem.scoreRule,
                            width: 120
                          });
                        }
                      }
                    }
                  );
                });

                if (this.purchaseType == "50" || this.purchaseType == "53") {
                  if (sumSkillChild.length + sumCommonChild.length < 3) {
                    if (this.type == 1) {
                      delete item.summaryColumns[6].width;
                    } else {
                      delete item.summaryColumns[7].width;
                    }
                  }
                  item.summaryColumns[4].labelChild = sumSkillChild;
                  if (this.type == 1) {
                    item.summaryColumns[5].labelChild = sumCommonChild;
                  }
                } else {
                  if (sumSkillChild.length + sumCommonChild.length < 3) {
                    if (this.type == 1) {
                      delete item.summaryColumns[7].width;
                    } else {
                      delete item.summaryColumns[8].width;
                    }
                  }
                  item.summaryColumns[7].labelChild = sumSkillChild;
                  item.summaryColumns[8].labelChild = sumCommonChild2;
                  item.summaryColumns[9].labelChild = sumCommonChild;
                  item.summaryColumns[10].labelChild = sumCommonChild3;
                  item.summaryColumns[11].labelChild = sumBidChild;
                }
              }
            });
            this.submitFlag = res1.some(
              item => item.summaryTableData.length > 0
            );
            this.listData = res1;
            console.log("this.listData", this.listData);
          }
          this.operateShow = true;
        });
      });
    },
    getSumAndExpertScore(packId, packName) {
      return new Promise((resolve, reject) => {
        // 汇总表
        scpQrySumScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId,
          purStep: this.$router.history.current.query.menuKey,
          evaPurStep: this.$router.history.current.query.evaPurStep,
          sumScoreType: this.type == 0 ? "0" : this.type == 2 ? "3" : "2"
        }).then(res => {
          let obj = {
            summaryTableData: [],
            packId: packId,
            packName: packName,
            expertList: []
          };
          obj.summaryTableData = res.data.data;
          let param = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            packId: packId,
            packName: packName
          };
          if (this.type == 0) {
            param.scoreItem = "0";
          } else {
            if (this.evaForm == "2") {
              param.scoreItem = "1";
            }
          }
          scpQrySumScoreExpertScoreListApi(param).then(res1 => {
            obj.expertList = res1.data.data;
            resolve(obj);
          });
        });
      });
    },
    // 打分表表格合并行列
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2 || columnIndex === row.columnCount - 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    operateSummary() {
      // 用于评分汇总保存   传purStep: "080607",查打分汇总
      // 分包件需要循环

      console.log(
        JSON.parse(JSON.stringify(this.listData)),
        "this.listData???????????"
      );
      let arr1 = [];
      this.listData.forEach(item => {
        let list = JSON.parse(JSON.stringify(item.summaryTableData));
        let arr = [];
        list.forEach(item => {
          let obj = {
            busiExtraSumScore: item.busiExtraSumScore,
            busiSumScore: item.busiSumScore,
            free5: item.free5,
            lostFlag: item.lostFlag,
            lostReason: item.lostReason,
            noTaxPriceAmount: item.noTaxPriceAmount,
            priceAmount: item.priceAmount,
            sscSupScoreSumItemBOS: item.sscSupScoreSumItemBOS,
            sumScore: item.sumScore,
            sumScoreType: item.sumScoreType,
            supCode: item.supCode,
            supJoinId: item.supJoinId,
            supName: item.supName,
            supPackQuoteId: item.supPackQuoteId,
            supQuoteId: item.supQuoteId,
            taxAmount: item.taxAmount,
            techExtraSumScore: item.techExtraSumScore,
            techSumScore: item.techSumScore,
            industryTypeName: item.industryTypeName,
            companyTypeName: item.companyTypeName
          };
          arr.push(obj);
        });
        arr1.push({
          packId: item.packId,
          packName: item.packName,
          sscSupScoreSumBOS: arr
        });
      });

      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        // packId: this.$router.history.current.query.packId,
        sumScoreType: 3,
        // sscSupScoreSumBOS: arr,
        scoringSummaryBOS: arr1,
        purStep: this.$router.history.current.query.menuKey,
        evaPurStep: this.$router.history.current.query.evaPurStep
        // purStep: "080607"
      };
      console.log(param, "param..................");
      scpDealSumScoreSaveApi(param).then(res => {
        if (res.data.code == "0") {
          this.$message({
            message: "提交汇总成功",
            type: "success",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.$emit("start", 3);
        }
      });
    },

    closeScro() {
      // 取消汇总
      this.$emit("start", 2);
    },

    // 提交
    dealSumScoreSubmit() {
      scpDealSumScoreSubmitApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        sumScoreType: this.type == 0 ? 0 : 2
      }).then(res => {
        if (res.data.code == "0") {
          this.$message({
            message: "提交成功",
            type: "success",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.refresh();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-table td {
  padding: 0 !important;
}
.remarkTip {
  color: #ff142f;
  margin-top: 19px;
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
/deep/ .el-tooltip {
  width: 100% !important;
}
</style>
